import {
  FrameShape,
  InnerBeam,
  SideWidths,
} from '@cutr/constants/windows/windows-geometry.ts';

import { ArcTopFrame } from './ArcTopFrame';
import { RectangleFrame } from './RectangleFrame';

type FrameProps = {
  frame: FrameShape;
  x: number;
  y: number;
  innerBeams: InnerBeam[];
  frameBeamWidthsMM?: SideWidths;
};

export const Frame = (props: FrameProps) => {
  if (props.frame.frameType === 'rectangle-arc-top') {
    return <ArcTopFrame {...props} />;
  }
  return <RectangleFrame {...props} />;
};
